import React from 'react';
import { Caption } from '@randajan/jet-react/dom/caption';
import { GradientImg } from './GradientImg/GradientImg';
import { siteContent, serviceAreas, referencesContent } from '../../content';
import { Reveal } from '../../elements/Reveal/Reveal';
import { useContact } from '../../frames/Contact/ContactProvider';

import { Welcome } from './Welcome/Welcome';
import { Divisions } from './Divisions/Divisions'
import { About } from './About/About'
import { ProofStrip } from './ProofStrip/ProofStrip';
import { References } from './References/References';

import sklad1 from '../../images/photos/skladlandingpage.jpg';
import sklad2 from '../../images/photos/skladlandingpage2.jpg';


import "./LandingPage.scss";


export const LandingPage = (props)=>{
    const {} = props;
    const contact = useContact();

    return (
        <section className="LandingPage">
            <main>
                <section className="LandingPage__hero">
                    <GradientImg src={sklad1} deg={"319"} col1={"rgba(130,0,0,0.8)"} col2={"rgba(0,0,130,0.8)"}></GradientImg>
                    <Welcome content={siteContent}></Welcome>
                </section>
                <section className="LandingPage__proof">
                    <ProofStrip items={siteContent.homepage.proofPoints}></ProofStrip>
                </section>
                <section id='divisionSelect' className="LandingPage__services">
                    <Divisions services={serviceAreas}></Divisions>
                </section>
                <section className="LandingPage__about">
                    <GradientImg src={sklad2} deg={"319"} col1={"rgba(0,0,100,0.8)"} col2={"rgba(0,0,100,0.8)"}></GradientImg>
                    <About content={siteContent.homepage}></About>
                </section>
                <section className="LandingPage__references">
                    <References content={referencesContent}></References>
                </section>
                <section className="LandingPage__contactCta">
                    <Reveal as="article" className="LandingPage__contactInner">
                        <span>Kontakt</span>
                        <Caption>Spojte se s ENERGOSPACE</Caption>
                        <p>{siteContent.contact.lead}</p>
                        <button type="button" onClick={contact.show}>Otevřít kontakt</button>
                    </Reveal>
                </section>
            </main>
        </section>
    )
}
